import { useState } from 'react';
import evaluationOpportunityRequestsApi, {
  type OpportunityRequestPatchedI,
} from 'Api/axios/evaluation-opportunity-requests-api';

const ERROR_MESSAGES: Record<number, string> = {
  409: 'Esta solicitud ya fue revisada',
  404: 'Solicitud no encontrada',
};

/**
 * Manages PATCH actions (approve / reject) for an opportunity request.
 * Exposes inlineError for 409 and 404 responses.
 */
const useAdminOpportunityActions = (
  requestId: string,
  onSuccess: (patched: OpportunityRequestPatchedI) => void
) => {
  const [submitting, setSubmitting] = useState(false);
  const [inlineError, setInlineError] = useState<string | null>(null);

  const patch = async (status: 'approved' | 'rejected', comment?: string) => {
    setSubmitting(true);
    setInlineError(null);

    const payload = status === 'rejected' && comment
      ? { status, comment }
      : { status };

    const response = await evaluationOpportunityRequestsApi.patch(requestId, payload);

    if (response.data) {
      onSuccess(response.data);
    } else if (response.httpStatus && ERROR_MESSAGES[response.httpStatus]) {
      setInlineError(ERROR_MESSAGES[response.httpStatus]);
    } else {
      setInlineError(response.error ?? 'Ocurrió un error al procesar la solicitud');
    }

    setSubmitting(false);
  };

  const approve = () => patch('approved');
  const reject = (comment: string) => patch('rejected', comment);

  return { submitting, inlineError, approve, reject };
};

export default useAdminOpportunityActions;
